import { config } from '@config';

const dashboardRoot = '/dashboard';

export const routes = {
  addIncentive: `${dashboardRoot}/incentives/add`,
  dashboard: dashboardRoot,
  editIncentive: (gid: string) => `${dashboardRoot}/incentives/edit/${gid}`,
  editIncentivePath: `${dashboardRoot}/incentives/edit/:gid`,
  forgotPassword: '/forgot-password',
  home: '/',
  impersonator: `/impersonator`,
  incentives: `${dashboardRoot}/incentives`,
  login: '/login',
  notFound: '/not-found',
  profile: `${dashboardRoot}/profile`,
  resetPassword: '/reset-password',
  settings: `${dashboardRoot}/settings`,
  signUp: '/signup',
};

export const givzQueyParams = {
  amount: 'amount',
  donationDescription: 'gz.donation.description.value',
  donationEmailPrompt: 'gz.donation.emailPrompt',
  donationEmailRequired: 'gz.donation.emailRequired',
  donationHideSearchBar: 'gz.donation.hideSearchBar',
  donationPrimaryColor: 'gz.donation.primaryColor',
  donationShowUSD: 'gz.donation.showUSD',
  donationTitle: 'gz.donation.title.value',
  landingPageBackgroundColor: 'gz.landingPage.backgroundColor',
  landingPageDescription: 'gz.landingPage.description.value',
  landingPageHero: 'gz.landingPage.hero',
  landingPageLogo: 'gz.landingPage.logo',
  landingPageTitle: 'gz.landingPage.title.value',
  landingPageWidgetOnly: 'gz.landingPage.widgetOnly',
  preview: 'gz.preview',
} as const;

export type GivzQueryParamsKey = keyof typeof givzQueyParams;
export type GivzQueryParams = Partial<Record<GivzQueryParamsKey, string>>;

export const withGivzQueryParams =
  (url: URL) => (queryParams: GivzQueryParams) => {
    for (const [key, value] of Object.entries(queryParams)) {
      if (value !== undefined) {
        url.searchParams.set(givzQueyParams[key as GivzQueryParamsKey], value);
      }
    }

    return url;
  };

export const donorAppRoutes = {
  generator: (params: { slug: string; queryParams?: GivzQueryParams }): URL => {
    const { queryParams = {}, slug } = params;
    const url = new URL([config.donorApp.baseUrl, 'c', slug].join('/'));
    return withGivzQueryParams(url)(queryParams);
  },
};
